<template>
	<div class="project-deliverable">
		<ul>
			<li>
				<span class="project-deliverable__label">Asset type</span>
				<span class="project-deliverable__content">{{ deliverable.title }}</span>
			</li>
			<li>
				<span class="project-deliverable__label">Qty</span>
				<span class="project-deliverable__content">{{ deliverable.quantity }}</span>
			</li>
			<li>
				<span class="project-deliverable__label">Price/unit:</span>
				<span class="project-deliverable__content">{{ price_per_unit }}</span>
			</li>
			<li>
				<span class="project-deliverable__label">Price per item:</span>
				<span class="project-deliverable__content">{{ price_per_unit_after_discount }} (after discount)</span>
			</li>
			<li>
				<span class="project-deliverable__label">Total:</span>
				<span
					class="project-deliverable__content"
					:class="{ 'project-deliverable__content--minus': total < 0 }"
				>
					{{ total }}
				</span>
			</li>
		</ul>
		<div class="project-deliverable__description">
			<span class="project-deliverable__label">Description</span>
			<div
				class="project-deliverable__content"
				v-html="deliverable.description"
			/>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { formatCurrency } from '../../helpers';

const props = defineProps( {
	deliverable: {
		type: Object,
		required: true
	},
	currency: {
		type: String,
		required: true,
		default: {
			label: 'USD'
		}
	}
} );

const price_per_unit = computed( () => {
	return formatCurrency( props.deliverable.price_per_unit, props.currency.label );
} );

const price_per_unit_after_discount = computed( () => {
	return formatCurrency( props.deliverable.price_per_unit_after_discount, props.currency.label );
} );

const total = computed( () => {
	return formatCurrency( props.deliverable.total, props.currency.label );
} );
</script>
